module.exports = __webpack_public_path__ + "static/media/marker-icon-red.fb9863da.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/marker-icon-red.png
 ** module id = 863
 ** module chunks = 0
 **/